<template>
  <el-card class="page_card" ref="card" v-loading="!is_ok">
    <div slot="header" class="clearfix">
      <span>装车量统计</span>
    </div>
    <el-form inline :model="selectForm" ref="selectForm">
      <el-form-item label="一次过磅时间">
          <el-date-picker
              v-model="selectForm.timeRange"
              type="datetimerange"
              align="right"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="装车撬位">
        <el-select
          v-model="selectForm.skid"
          multiple
          collapse-tags
          placeholder="请选择"
        >
          <el-option
            v-for="item in skids"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button plain type="primary" @click="selectSubmit()"
          >查 询</el-button
        >
        <el-button plain @click="resetSelect()">重 置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      :data="list"
      :max-height="tableMaxHeight"
    >
      <el-table-column label="撬位号" width="" align="center">
        <template slot-scope="scope">
          <span class="primary_text">{{ scope.row.skid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="装车数" width="" align="center">
        <template slot-scope="scope">
          <span class="primary_text">{{ scope.row.carNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="装车量(吨)" width="" align="center">
        <template slot-scope="scope">
          <span class="primary_text">{{ scope.row.volume }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "loadVolumeStatistics",
  data() {
    return {
      is_ok: false,
      selectForm: {
        timeRange:[],
        skid: []
      },
      skids: [
        {
          value: 1,
          label: 1,
        },
        {
          value: 2,
          label: 2,
        },
        {
          value: 3,
          label: 3,
        },
        {
          value: 4,
          label: 4,
        },
        {
          value: 5,
          label: 5,
        },
        {
          value: 6,
          label: 6,
        },
        {
          value: 7,
          label: 7,
        },
        {
          value: 8,
          label: 8,
        },
        {
          value: 9,
          label: 9,
        },
        {
          value: 10,
          label: 10,
        },
        {
          value: 11,
          label: 11,
        },
        {
          value: 12,
          label: 12,
        },
      ],
      tableMaxHeight: 0,
      total: 0,
      list: [],
      listData: {},
    };
  },
  methods: {
    resetSelect() {
      this.selectForm = {
        timeRange:[],
        skid: [],
      };
      this.$refs["selectForm"].resetFields();
      this.getData();
    },
    selectSubmit() {
      this.getData();
    },
    getData() {
      if(this.selectForm.timeRange == null || this.selectForm.timeRange == ''){
          this.selectForm.timeRange = []
      }
      request
        .post("report/skid", this.selectForm)
        .then((res) => {
          this.list = res.data;
          this.listData=res;
          this.is_ok = true;
          this.tableMaxHeight =
            this.$refs.card.$el.offsetHeight -
            this.$refs.selectForm.$el.offsetHeight -
            105;
        })
        .catch((err) => {
          this.is_ok = true;
          this.tableMaxHeight =this.$refs.card.$el.offsetHeight -this.$refs.selectForm.$el.offsetHeight -105;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else if (index === 1) {
          sums[index] = this.listData.carNum;
          return;
        } else if (index === 2) {
          sums[index] = this.listData.volume;
          return;
        }
      });
      return sums;
    },
    getNextDate(date,day){
      let dd=new Date(date);
      dd.setDate(dd.getDate()+day);
      let y=dd.getFullYear();
      let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
      let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
      return y+'-'+m+'-'+d;
    }
  },
  created() {},
  mounted() {
    let dd=new Date();
    let y=dd.getFullYear();
    let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
    let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
    let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 08:00:00`
    let endTime=`${this.getNextDate(y+'-'+m+'-'+d,+0)} 07:59:59`
    this.selectForm.timeRange.push(startTime,endTime)
    this.getData();
  },
};
</script>
<style scoped lang="scss">
</style>
